import { SETTINGS_V2_MASTER_ROUTE } from '../main/main.data';

export const SETTINGS_INVOICE_STYLE_ROUTE = 'invoice-style';
export const SETTINGS_INVOICE_LAYOUT_CONTENT_ROUTE = 'invoice-layout-content';
export const SETTINGS_ACCOUNT_DETAILS_ROUTE = 'account-details';
export const SETTINGS_MANAGE_SUBSCRIPTION_ROUTE = 'manage-subscription';
export const SETTINGS_SECURITY_ROUTE = 'security';
export const SETTINGS_PERSONAL_INFO_ROUTE = 'personal-info';
export const SETTINGS_COMPANY_PROFILE_ROUTE = 'company-profile';
export const SETTINGS_COMPANY_INFO_ROUTE = 'info';
export const SETTINGS_COMPANY_REVIEWS_ROUTE = 'reviews';
export const SETTINGS_TAX_AND_CURRENCY_ROUTE = 'tax-and-currency';
export const SETTINGS_LANGUAGE_ROUTE = 'language';
export const SETTINGS_CLIENT_PAYMENT_OPTIONS_ROUTE = 'client-payment-options';
export const SETTINGS_CLIENT_COMMUNICATION_ROUTE = 'client-communication';
export const SETTINGS_TEAM_MEMBERS_ROUTE = 'team-members';
export const SETTINGS_INVOICE_DESIGN_ROUTE = 'invoice-design';
export const SETTINGS_INVOICE_OPTIONS_ROUTE = 'invoice-options';
export const SETTINGS_EXPORT_TOOL_ROUTE = 'export-tool';
export const SETTINGS_XERO_ROUTE = 'xero';
export const REVIEWS_REQUEST_ROUTE = 'request';
export const REVIEWS_REQUEST_SEND_ROUTE = 'request-send';
export const REVIEWS_DETAIL_ROUTE = 'detail';

export const COMPANY_INFO_PATH = [
  SETTINGS_V2_MASTER_ROUTE,
  SETTINGS_COMPANY_PROFILE_ROUTE,
  SETTINGS_COMPANY_INFO_ROUTE,
];
export const REVIEWS_PATH = [
  SETTINGS_V2_MASTER_ROUTE,
  SETTINGS_COMPANY_PROFILE_ROUTE,
  SETTINGS_COMPANY_REVIEWS_ROUTE,
];
export const REVIEWS_MASTER_ROUTE = `/${SETTINGS_V2_MASTER_ROUTE}/${SETTINGS_COMPANY_PROFILE_ROUTE}/${SETTINGS_COMPANY_REVIEWS_ROUTE}`;
export const INVOICE_OPTIONS_MASTER_ROUTE = `/${SETTINGS_V2_MASTER_ROUTE}/${SETTINGS_INVOICE_OPTIONS_ROUTE}`;
export const REVIEWS_DETAIL_PATH = [...REVIEWS_PATH, REVIEWS_DETAIL_ROUTE];
export const REVIEW_REQUEST_PATH = [...REVIEWS_PATH, REVIEWS_REQUEST_ROUTE];

export enum EmployeesRadioEnum {
  just_me = 'just_me',
  there_are_more = 'there_are_more',
}
